import { routes } from "@libs/routing/routes.ts";
import { ClinicalStore } from "@stores/clinical/ClinicalStore.ts";
import { EpisodeOfCare } from "@stores/clinical/models/EpisodeOfCare.ts";
import { useStores } from "@stores/hooks/useStores.ts";
import { CardFormLayout } from "@ui-components/card-form-layout/CardFormLayout.tsx";
import { DataFetcher } from "@ui-components/data-fetcher/DataFetcher.tsx";

import { ConditionCards } from "./components/ConditionCards.tsx";
import { ConditionHeader } from "./components/ConditionHeader.tsx";

export enum ConditionCardIds {
  overview = "Overview"
}

interface ConditionScreenBaseProps {
  episodeOfCare: EpisodeOfCare;
}

const ConditionScreenBase: React.FC<ConditionScreenBaseProps> = ({
  episodeOfCare
}) => {
  return (
    <CardFormLayout
      styles={{
        subComponentStyles: {
          topBarWrapper: { root: { margin: "-16px" } }
        }
      }}
      sideRailMenuItems={[
        {
          id: ConditionCardIds.overview,
          text: "Overview"
        }
      ]}
      header={<ConditionHeader episodeOfCare={episodeOfCare} />}
    >
      <ConditionCards episodeOfCare={episodeOfCare} />
    </CardFormLayout>
  );
};

const ConditionScreen = () => {
  const root = useStores();
  const episodeOfCareId = routes.conditions.summary.match(
    root.routing.location.pathname
  )?.params.id;

  if (!episodeOfCareId) {
    return null;
  }

  const fetch = async (clinical: ClinicalStore) => {
    const episodeOfCare = await clinical.getEpisodeOfCare(episodeOfCareId);
    await Promise.all([
      episodeOfCare.loadPatient(),
      episodeOfCare.loadClaim(),
      episodeOfCare.loadCalendarEvents()
    ]);

    return episodeOfCare;
  };

  return (
    <DataFetcher<EpisodeOfCare> fetch={({ clinical }) => fetch(clinical)}>
      {episodeOfCare => <ConditionScreenBase episodeOfCare={episodeOfCare} />}
    </DataFetcher>
  );
};
// ⚠ It should be exported as default since it is used for React.lazy
// eslint-disable-next-line import/no-default-export
export default ConditionScreen;
